(() => {
  if (window.__YIZCHO_ARTIST_RETURN_TO_BIO_V01__) return;
  window.__YIZCHO_ARTIST_RETURN_TO_BIO_V01__ = true;

  const query = new URLSearchParams(window.location.search);
  if (query.get("artist") !== "1") return;

  const candidate = query.get("return_to");
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//") || candidate.includes("\\")) {
    return;
  }

  let target;
  try {
    const resolved = new URL(candidate, window.location.origin);
    if (resolved.origin !== window.location.origin) return;
    target = `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return;
  }

  const returnToBio = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(target);
  };

  const bind = () => {
    const topButton = document.querySelector("#castle-experience-back");
    const closeButton = document.querySelector("#castle-experience-close");
    const footerButton = document.querySelector("#artist-story-return");
    const footer = footerButton?.closest(".artist-story__closing");
    const topLabel = document.querySelector("#castle-experience-back-label");
    if (!topButton || !footerButton || !topLabel) return false;

    topButton.addEventListener("click", returnToBio, true);
    closeButton?.addEventListener("click", returnToBio, true);
    footerButton.addEventListener("click", returnToBio, true);

    const syncLabels = () => {
      if (topLabel.textContent !== "Back to Bio") topLabel.textContent = "Back to Bio";
      if (topButton.getAttribute("aria-label") !== "Back to Bio") {
        topButton.setAttribute("aria-label", "Back to Bio");
      }
      if (footerButton.textContent !== "Return to Bio") footerButton.textContent = "Return to Bio";
      if (footer) {
        footer.style.setProperty("display", "flex", "important");
        footer.style.setProperty("flex-direction", "column", "important");
        footer.style.setProperty("align-items", "center", "important");
        footer.style.setProperty("text-align", "center", "important");
      }
      footerButton.style.setProperty("justify-self", "center", "important");
      footerButton.style.setProperty("margin-inline", "auto", "important");
      footerButton.style.setProperty("margin-block-start", "clamp(40px, 8vw, 64px)", "important");
      footerButton.style.setProperty("width", "fit-content", "important");
      footerButton.style.setProperty("display", "inline-flex", "important");
      footerButton.style.setProperty("align-items", "center", "important");
      footerButton.style.setProperty("justify-content", "center", "important");
      footerButton.style.setProperty("text-align", "center", "important");
      footerButton.style.setProperty("line-height", "1.1", "important");
    };
    syncLabels();
    new MutationObserver(syncLabels).observe(topLabel, { childList: true, characterData: true, subtree: true });
    new MutationObserver(syncLabels).observe(footerButton, { childList: true, characterData: true, subtree: true });
    new MutationObserver(syncLabels).observe(topButton, { attributes: true, attributeFilter: ["aria-label"] });
    return true;
  };

  const bindWhenReady = () => {
    if (bind()) return;
    const startedAt = Date.now();
    const timer = window.setInterval(() => {
      if (bind() || Date.now() - startedAt > 12000) window.clearInterval(timer);
    }, 120);
  };

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const artistStage = document.querySelector("#castle-artist-stage");
    if (!artistStage || artistStage.hidden) return;
    returnToBio(event);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindWhenReady, { once: true });
  } else {
    bindWhenReady();
  }
})();
